window.addEventListener('load', () => {
  // PCのスタイルを適用する横幅の場合は何もしない
  if (window.innerWidth >= 989) return

  const productElement = document.querySelector('#product')

  // 全角スペースを半角スペースに置き換え
  if (productElement) {
    productElement.innerHTML = productElement.innerHTML.replace(/　/g, ' ')
  }

  const advantageElements = document.querySelectorAll('.advantage-item_category')

  advantageElements.forEach(element => {
    element.innerHTML = element.innerHTML.replace(/・/g, '・<br>')
  })
})
